<template>
  <Toast position="bottom-center" />
  <ConfirmDialog>
    <template #message="slotProps">
      <div style="white-space: pre-line">
        {{ slotProps.message.message }}
      </div>
    </template>
  </ConfirmDialog>
  <RouterView v-slot="{ Component }">
    <Suspense>
      <template #default>
        <component :is="Component" />
      </template>
      <template #fallback>
        <div class="flex items-center justify-center min-h-screen">
          <ProgressSpinner
            style="width: 50px; height: 50px"
            stroke-width="4"
            animation-duration="1s"
          />
        </div>
      </template>
    </Suspense>
  </RouterView>
</template>

<script setup lang="ts">
import { RouterView } from "vue-router";
import Toast from "primevue/toast";
import ConfirmDialog from "primevue/confirmdialog";
import ProgressSpinner from "primevue/progressspinner";
</script>

<style>
/* Constrain ConfirmDialog width to make it more compact and square-like */
.p-confirmdialog {
  max-width: 450px !important;
  width: 90% !important;
}

.p-confirmdialog .p-dialog-content {
  padding: 1.5rem !important;
}

.p-confirmdialog .p-dialog-footer {
  padding: 1rem 1.5rem !important;
  gap: 0.5rem !important;
}

.p-confirmdialog .p-confirm-dialog-message {
  white-space: pre-line;
  line-height: 1.6;
}
</style>
